<template functional>
  <component
    :is="props.tag"
    :class="data.class"
    class="event-list grid grid-gap-20"
  >
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'ul',
    },
  },
};
</script>

<style scoped>
.event-list {
  grid-template-columns: repeat(auto-fit, minmax(auto, 450px));
}

@screen laptop-l {
  .event-list {
    grid-template-columns: repeat(auto-fit, minmax(auto, 500px));
  }
}

@screen 4k {
  .event-list {
    grid-template-columns: repeat(auto-fit, minmax(auto, 600px));
  }
}
</style>
